import { render, staticRenderFns } from "./Dokumen.vue?vue&type=template&id=254e454a&scoped=true&"
import script from "./Dokumen.vue?vue&type=script&lang=js&"
export * from "./Dokumen.vue?vue&type=script&lang=js&"
import style0 from "./Dokumen.vue?vue&type=style&index=0&id=254e454a&prod&scoped=true&lang=css&"
import style1 from "./Dokumen.scss?vue&type=style&index=1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254e454a",
  null
  
)

export default component.exports